/* eslint object-curly-newline: 0 */
/* eslint no-underscore-dangle: 0 */
/* eslint camelcase: 0 */
import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    routeQuerySent: false,
    _platform_key: null,
    zis_locale: null,
    last_url: null,
    mandate: null,
    mandate_slug: null,
    isLoading: false,
    error: null,
    notification: null,
    allParkingLotSocketConnected: false,
    singleParkingLotSocketConnected: [],
  },
  mutations: {
    CHANGE_LANGUAGE(state, newLang) {
      if (newLang) {
        state.zis_locale = newLang;
        localStorage.setItem('zis_local', newLang);
      } else {
        state.zis_locale = 'de';
        localStorage.setItem('zis_local', 'de');
      }
    },
    SET_PLATFORM_KEY(state, platformKey) {
      if (platformKey) {
        state._platform_key = platformKey;
        localStorage.setItem('_platform_key', platformKey);

        const parts = platformKey.split('.');
        const claims = JSON.parse(atob(parts[1]));
        state.mandate = claims.mid;
        if (state.mandate) localStorage.setItem('mandate', state.mandate);
      } else {
        return false;
      }
      return true;
    },
    SET_BACKLINK(state, backLink) {
      if (backLink) {
        state.last_url = backLink;
        localStorage.setItem('last_url', backLink);
      } else {
        state.last_url = 'https://element-iot.com/';
        localStorage.setItem('last_url', 'https://element-iot.com/');
      }
    },
    SET_MANDATE(state, mandateParam) {
      if (mandateParam) {
        state.mandate = mandateParam;
        localStorage.setItem('mandate', mandateParam);
      } else {
        return false;
      }
      return true;
    },
    SET_MANDATE_SLUG(state, mandateParam) {
      if (mandateParam) {
        state.mandate_slug = mandateParam;
        localStorage.setItem('mandate_slug', mandateParam);
      } else {
        return false;
      }
      return true;
    },
    SHOW_ERROR(state, error) {
      state.error = error;
    },
    CLOSE_ERROR(state) {
      state.error = null;
    },
    SHOW_NOTIFICATION(state, notification) {
      state.notification = notification;
    },
    CLOSE_NOTIFICATION(state) {
      state.notification = null;
    },
  },
  actions: {
    SET_APP_PARAMS({ commit }, payload) {
      let { _platform_key, zis_locale, last_url } = payload;
      if (!_platform_key) _platform_key = localStorage.getItem('_platform_key');
      if (!zis_locale) zis_locale = localStorage.getItem('zis_locale');
      if (!last_url) last_url = localStorage.getItem('last_url');

      commit('SET_PLATFORM_KEY', _platform_key);
      commit('CHANGE_LANGUAGE', zis_locale);
      commit('SET_BACKLINK', last_url);
    },
  },
  getters: {},
});
